import { DataFieldRuleValidator } from "./types";

export const dataFieldNotUpdatable: DataFieldRuleValidator = {
	validate: () => {
		return true;
	},

	getErrorMessage: ({ t }) => {
		return t("Field is not updatable");
	},
};
